module.exports = __webpack_public_path__ + "c58612461ce7d81eb3067dacaf7ad07b.png";